import axios from 'axios';
import moment from 'moment';

class MitSpacesService {
  constructor() {
    this.spaceBuildingId = 1;//default, not ideal, but for now...
    this.SPACE_TYPES = {
      building:{
            name: 'Building',
            id: 'building'
      },
      floor:{
            name: 'Floor',
            id: 'floor'
      },
      room:{
            name: 'Room',
            id: 'room'
      },
      area: {
            name: 'Area',
            id: 'area'
      }
    };
    this.SPACE_TYPES_DEFAULT = this.SPACE_TYPES.room;
    this.SPACE_TYPES_ARRAY = [];//array version, helper for things like selection boxes that need an array.

    for(let k in this.SPACE_TYPES){
      this.SPACE_TYPES_ARRAY.push(this.SPACE_TYPES[k]);
    }
  }

  generateRoomEntrances(buildingId, level = null) {
      return new Promise((resolve, reject) => {
          let url = '/api/v2/admin/spaces/buildings/' + buildingId + '/navigation/generate-entrances';
          if (level) {
              url += '?level=' + encodeURIComponent(level);
          }
          
          axios.post(url)
              .then((response) => resolve(response.data))
              .catch((error) => reject(error));
      });
  }

  adaptTreeToUIModel(tree){
    tree = this.adaptToUIModel(tree);

    if(tree.children && tree.children.length > 0){
      for(let x = 0; x < tree.children.length; x++){
        this.adaptTreeToUIModel(tree.children[x]);
      }
    }
  }
  adaptTreeToAPIModel(tree){
    tree = this.adaptToAPIModel(tree);

    if(tree.children && tree.children.length > 0){
      for(let x = 0; x < tree.children.length; x++){
        this.adaptTreeToAPIModel(tree.children[x]);
      }
    }
  }
  adaptToUIModel(space){
    space.ui = {
      lastEditedDt: space.lastEditDt ? moment(space.lastEditedDt).local().fromNow() : null
    };
    switch(space.spaceType){
        case 'campus':
            space.ui.icon = 'mdi-domain';
            break;
        case 'building':
            space.ui.icon = 'mdi-office-building-outline';
            break;
        case 'floor':
            space.ui.icon = 'mdi-floor-plan';
            break;
        case 'space':
            space.ui.icon = 'mdi-door-open';
            break;
    }
    return space;
  }
  adaptToAPIModel(space){
    space.type = space.type.id;
    delete space.dates_local;
    return space;
  }

  getGroups() {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/user/spaces/groups')
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }

  saveGroup(group) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v2/manager/spaces/groups', group)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }

  deleteGroup(id) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/v2/manager/spaces/groups/' + id)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }

  getBuildings() {
    return new Promise ((resolve, reject) => {
      // Note: Replaced duplicate v2 route with original v1 route logic. 
      // If your backend handles both, this prevents duplicate declarations.
      axios.get('/api/v1/user/spaces/buildings')
        .then((response) => resolve(response.data.buildings))
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response ? error.response.data : error);
        });
    });
  }

  getBuildingFloors() {
    return new Promise ((resolve, reject) => {
     axios.get('/api/v1/user/spaces/buildings/'+this.spaceBuildingId+'?spaceTypes=floor,building')
        .then((response) => resolve(response.data.buildings))
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response ? error.response.data : error);
        });
    });
  }

  getAllSpacesAndObjects() {
        // By omitting buildingId and types, the backend defaults to 
        // returning both 'space' and 'object' types for all buildings.
        return axios.get('/api/v2/user/spaces/?types=space,object')
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.error('MitSpacesService: Error fetching campus spaces and objects', error);
                throw error;
            });
    }

  getSpaces(options) {
    return new Promise ((resolve, reject) => {
        let url = new URL(window.location.origin+'/api/v2/user/spaces');
        for (let prop in options) {
          if (options.hasOwnProperty(prop)) {
            url.searchParams.append(prop, options[prop]);
          }
        }
      axios.get(url.pathname+url.search)
        .then((response) => {
            for(let x = 0; x < response.data.spaces.length; x++){
              response.data.spaces[x] = this.adaptToUIModel(response.data.spaces[x]);
            }
            return resolve(response.data.spaces);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });
    });
  }

  getSpacesList(buildingId) {
    return new Promise ((resolve, reject) => {
      axios.get('/api/v2/user/spaces/?buildingId='+buildingId)
        .then((response) => {
            let data = response.data;
            data.spacesNameDictionary = {};
            for(let x = 0; x < data.spaces.length; x++){
              data.spaces[x] = this.adaptToUIModel(data.spaces[x]);
              data.spacesNameDictionary[data.spaces[x].name] = data.spaces[x];
            }
            return resolve(data);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response ? error.response.data : error);
        });
    });
  }

  getAllSpacesList() {
    return new Promise ((resolve, reject) => {
      axios.get('/api/v2/user/spaces/?types=space')
        .then((response) => {
            let data = response.data;
            data.spacesNameDictionary = {};
            for(let x = 0; x < data.spaces.length; x++){
              data.spaces[x] = this.adaptToUIModel(data.spaces[x]);
              data.spacesNameDictionary[data.spaces[x].name] = data.spaces[x];
            }
            return resolve(data);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response ? error.response.data : error);
        });
    });
  }

  getBuildingSpacesTree() {
    return new Promise ((resolve, reject) => {
      axios.get('/api/v2/user/spaces/tree')
        .then((response) => {
            let campus = this.campus = {
                mitId:'campus',
                displayName:'Campus',
                spaceType:'campus',
                children:response.data.campus
            };
            this.adaptTreeToUIModel(campus);
            return resolve(campus);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });
    });
  }

  getBuildingCoordinates(buildingId, options) {
    return new Promise ((resolve, reject) => {
        let url = new URL(window.location.origin+'/api/v2/user/spaces/buildings/'+buildingId+'/coordinates');
        for (let prop in options) {
          if (options.hasOwnProperty(prop)) {
            url.searchParams.append(prop, options[prop]);
          }
        }
      axios.get(url.pathname+url.search)
        .then((response) => resolve(response.data.coordinates))
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response ? error.response.data : error);
        });
    });
  }

  getBuildingGeoJson(buildingId,options) {
    return new Promise ((resolve, reject) => {
        let url = new URL(window.location.origin+'/api/v2/user/spaces/buildings/'+buildingId+'/geojson');
        for (let prop in options) {
          if (options.hasOwnProperty(prop)) {
            url.searchParams.append(prop, options[prop]);
          }
        }
      axios.get(url.pathname+url.search)
        .then((response) => resolve(response.data.geojson))
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response ? error.response.data : error);
        });
    });
  }

  getAllBuildingStats() {
    return new Promise ((resolve, reject) => {
        axios.get('/api/v2/user/spaces/all/buildings/stats')
            .then((response) => resolve(response.data))
            .catch((error) => {
              console.log('ERROR:', error);
              return reject(error.response ? error.response.data : error);
            });
    });
  }

  getBuildingStats(buildingId,version) {
    return new Promise ((resolve, reject) => {
        let url = '/api/v2/user/spaces/buildings/'+buildingId+'/stats';
        if(version) url += '?version='+version;
        
        axios.get(url)
            .then((response) => resolve(response.data))
            .catch((error) => {
              console.log('ERROR:', error);
              return reject(error.response ? error.response.data : error);
            });
    });
  }

  getBuildingsMitIdUniqueList() {
    if(this.buildingsMitIdUniqueList){
        return Promise.resolve(this.buildingsMitIdUniqueList);
    }
    if(this.promiseBuildingsMitIdUniqueList){
        return this.promiseBuildingsMitIdUniqueList;
    }

    this.promiseBuildingsMitIdUniqueList = new Promise ((resolve, reject) => {
      axios.get('/api/v2/user/spaces/buildings/uniqueids')
        .then((response) => {
            this.promiseBuildingsMitIdUniqueList = null;
            return resolve(response.data.buildings);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          this.promiseBuildingsMitIdUniqueList = null;
          return reject(error.response ? error.response.data : error);
        });
    });
    return this.promiseBuildingsMitIdUniqueList
  }

  convertGeoJSONListtoSpaceModel(spaceGeojson){
      let spaceList = [];
      for(let x = 0; x < spaceGeojson.length; x++){
          spaceList.push(spaceGeojson[x].properties);
      }
      return spaceList;
  }

  saveSpaces(spacesList){
      return new Promise ((resolve, reject) => {
        axios.post('/api/v2/manager/spaces/list', spacesList)
          .then((response) => resolve(response.data))
          .catch((error) => {
            console.log('ERROR:', error);
            return reject(error.response ? error.response.data : error);
          });
      });
  }

  deleteSpaces(spacesList){
      let listIds = spacesList[0].id;
      for(let x = 1; x < spacesList.length; x++){
          listIds += ','+spacesList[x].id;
      }
      return new Promise ((resolve, reject) => {
        axios.delete('/api/v2/manager/spaces/list?ids='+listIds)
          .then((response) => resolve(response.data))
          .catch((error) => {
            console.log('ERROR:', error);
            return reject(error.response ? error.response.data : error);
          });
      });
  }

  // ---- Navigation API Integrations ----
  getNavigation(buildingMitId) {
        // Hitting the new manager endpoint
        return axios.get(`/api/v2/user/spaces/buildings/${buildingMitId}/navigation`)
            .then(res => res.data)
            .catch(err => {
                console.error("Error fetching building navigation:", err);
                return { features: [] };
            });
    }

  saveNavigation(payload) {
    const requestBody = {
        created: payload.upsert || [],
        modified: [], 
        deleted: payload.delete || []
    };

    return new Promise ((resolve, reject) => {
        axios.post('/api/v2/manager/spaces/navigation', requestBody)
          .then((response) => resolve(response.data))
          .catch((error) => {
            console.log('ERROR:', error);
            return reject(error.response ? error.response.data : error);
          });
    });
  }
  // -------------------------------------

  getExistingBuildingObjectMitIds(buildingMitId){
      return new Promise ((resolve, reject) => {
        axios.get('/api/v2/manager/spaces/'+buildingMitId+'/mitids')
          .then((response) => resolve(response.data.existing))
          .catch((error) => {
            console.log('ERROR:', error);
            return reject(error.response ? error.response.data : error);
          });
      });
  }

  copyObjects(buildingMitId, fromVersion, toVersion) {
    return new Promise ((resolve, reject) => {
      axios.post('/api/v2/admin/spaces/buildings/'+buildingMitId+'/objects/copy', {
          fromVersion:fromVersion,
          toVersion:toVersion
      })
        .then((response) => resolve(response.data))
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });
    });
  }

  deleteObjects(buildingMitId, fromVersion) {
    return new Promise ((resolve, reject) => {
      axios.delete('/api/v2/admin/spaces/buildings/'+buildingMitId+'/'+fromVersion+'/objects/delete')
        .then((response) => resolve(response.data))
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });
    });
  }

  copySpaceNames(buildingMitId, fromVersion, toVersion) {
    return new Promise ((resolve, reject) => {
      axios.post('/api/v2/admin/spaces/buildings/'+buildingMitId+'/spaces/copy/data', {
          fromVersion:fromVersion,
          toVersion:toVersion
      })
        .then((response) => resolve(response.data))
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });
    });
  }

  uploadSpaceImage(spaceId, image, imageIndex){
    return new Promise ((resolve, reject) => {
        let formData = new FormData();
        formData.append("spaceId", spaceId);
        formData.append("imageIndex", imageIndex);
        formData.append("image", image);

        axios.post('/api/v2/manager/spaces/images', formData, {headers: {'Content-Type': 'multipart/form-data'} })
            .then((response) => resolve(response.data))
            .catch((error) => {
              console.log('ERROR:', error);
              return reject(error);
            });
    });
  }
  
  deleteSpaceImage(imageName){
    return new Promise ((resolve, reject) => {
        axios.delete('/api/v2/manager/spaces/images/'+imageName)
            .then((response) => resolve(response.data))
            .catch((error) => {
              console.log('ERROR:', error);
              return reject(error);
            });
    });
  }

}

export default new MitSpacesService();